angular.module('bb.messaging').config(MessagingRoutes);

MessagingRoutes.$inject = ['$routeProvider'];
function MessagingRoutes($routeProvider) {
  $routeProvider.when('/listing/send/:lids', {
    template: '<bb-listing-send />',
  });
}

export {};
